import React, { Fragment } from 'react'
import { Link } from 'react-router'
import styles from './Share.scss'
import { SectionBox } from 'common/styleguide/SectionBox'
import { EXPERIENCE_EVENT_EMBED_MODAL } from 'common/modals/ExperienceEventEmbedModal'
import { showModal } from 'lib/modalUtils'

import qrIcon from './images/qr-icon.png'
import qrIcon2x from './images/qr-icon@2x.png'
import qrIcon3x from './images/qr-icon@3x.png'
import shortcutIcon from './images/shortcut-icon.png'
import shortcutIcon2x from './images/shortcut-icon@2x.png'
import shortcutIcon3x from './images/shortcut-icon@3x.png'
import embedIcon from './images/embed-icon.png'
import embedIcon2x from './images/embed-icon@2x.png'
import embedIcon3x from './images/embed-icon@3x.png'

export class Share extends React.PureComponent {
  render () {
    const { isPublished, experience } = this.props
    const { publicEmbed } = experience.permissions

    return (
      <Fragment>
        <SectionBox title='Share'>
          <p>
            Share your Experience using Shortcut Code, QR image, Share Page, or Embed Code.
          </p>
          <div className={styles.links}>
            {isPublished
              ? <Fragment>
                <Link to={`/experiences/${experience.id}/shortcut`}>
                  <img
                    src={qrIcon}
                    srcSet={`${qrIcon} 1x, ${qrIcon2x} 2x, ${qrIcon3x} 3x`} />
                  Shortcut Code & QR
                </Link>
                <Link to={`/experiences/${experience.id}/view_config`}>
                  <img
                    src={shortcutIcon}
                    srcSet={`${shortcutIcon} 1x, ${shortcutIcon2x} 2x, ${shortcutIcon3x} 3x`} />
                  Share Page
                </Link>
                {publicEmbed && <a onClick={() => showModal(EXPERIENCE_EVENT_EMBED_MODAL, { objectType: 'experience', objectId: experience.id })}>
                  <img
                    src={embedIcon}
                    srcSet={`${embedIcon} 1x, ${embedIcon2x} 2x, ${embedIcon3x} 3x`} />
                  Embed Code
                </a>}
              </Fragment>
              : <Fragment>
                <span data-tip title='This Experience needs to be published before it can be shared' className={styles.disabledLink}>
                  <img
                    src={qrIcon}
                    srcSet={`${qrIcon} 1x, ${qrIcon2x} 2x, ${qrIcon3x} 3x`} />
                  Shortcut Code & QR
                </span>
                <span data-tip title='This Experience needs to be published before it can be shared' className={styles.disabledLink}>
                  <img
                    src={shortcutIcon}
                    srcSet={`${shortcutIcon} 1x, ${shortcutIcon2x} 2x, ${shortcutIcon3x} 3x`} />
                  Share Page
                </span>
                {publicEmbed && <span data-tip title='This Experience needs to be published before it can be shared' className={styles.disabledLink}>
                  <img
                    src={embedIcon}
                    srcSet={`${embedIcon} 1x, ${embedIcon2x} 2x, ${embedIcon3x} 3x`} />
                  Embed Code
                </span>}
              </Fragment>
            }
          </div>
        </SectionBox>
      </Fragment>
    )
  }
}
